export const locale = {
  lang: 'en',
  data: {
    TOOLBAR: {
      ACCOUNT_AREA: 'Type of account',
      ACCOUNT_AREAS: { CUSTOMER: 'Client area', LABORATORY: 'Laboratory area' },
      API_CREDENTIALS: 'API keys',
      APPLICATION_SETTINGS: 'Application Settings',
      COLOR_THEMES_TITLE: 'Theme',
      COLOR_THEMES: { LIGHT: 'Light', DARK: 'Dark', SYSTEM: 'System' },
      LOGOUT: 'Sing Out',
      MY_ACCOUNT: 'My Account',
      USER_MANAGEMENT: 'user management',
    },
  },
};
